import { DateUtils } from '../DateUtils';

export const CurrentSearchToSessionStorageValues = (input) => {
    const { segments = [], rooms = [] } = input;

    const destination = segments[0]?.destination ? segments[0].destination : {};
    const dates = {
        checkin: segments?.[0]?.date ? DateUtils.toString(segments[0].date) : {},
        checkout: segments?.[1]?.date ? DateUtils.toString(segments[1].date) : {}
    };
    const transformedRooms = rooms ? rooms.map((room) => ({
        id: room.id,
        adults: room.adults,
        kids: room.kids
    })) : [];

    return {
        destination,
        dates,
        rooms: transformedRooms
    };
};
